import { render, staticRenderFns } from "./comparisonTab.vue?vue&type=template&id=265863f1&scoped=true&"
import script from "./comparisonTab.vue?vue&type=script&lang=js&"
export * from "./comparisonTab.vue?vue&type=script&lang=js&"
import style0 from "./comparisonTab.vue?vue&type=style&index=0&id=265863f1&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265863f1",
  null
  
)

export default component.exports